<div class="auth-full-height d-flex flex-row align-items-center">
    <div class="container">
       <div class="row justify-content-center">
           <div class="col-md-4">
                <div class="card">
                    <div class="card-body">
                        <div class="m-2">
                            <div class="d-flex justify-content-center mt-3">
                                <img style="max-width:300px;width: 100%;" src="/assets/images/Logo-01.png" alt="">
                            </div>
                            <div class="text-center mt-3">
                                <h3 class="fw-bolder">{{"Sign Up"  | translate}}</h3>
                                <p class="text-muted">{{"Sign up account to get free reward!" | translate}}</p>
                            </div>
                            <register-form></register-form>
                        </div>
                    </div>
                </div>
           </div>
       </div> 
    </div>
</div>